import { useEffect } from 'react'
import { useVerificationFlow } from '../../VerificationFlowContext'

/**
 * VerifyingView Component
 *
 * Checks if the membership is verified and dispatches the appropriate event.
 */
const VerifyingView = () => {
  const { state, dispatch } = useVerificationFlow()
  const { currentPartnerType } = state

  // Get the appropriate membership based on current partner type
  const getMembership = () => {
    switch (currentPartnerType) {
      case 'RealEstateAgent':
        return state.realEstateAgentMembership
      case 'LoanOfficer':
        return state.loanOfficerMembership
      case 'InsuranceAgent':
        return state.insuranceAgentMembership
      default:
        return state.loanOfficerMembership
    }
  }

  const membership = getMembership()

  const handleVerified = () => {
    dispatch({ type: 'SUCCESS' })
  }

  const handleUnverified = () => {
    dispatch({ type: 'FAILURE' })
  }

  useEffect(() => {
    if (!membership) {
      // No membership to verify, treat as failure
      handleUnverified()
      return
    }

    if (membership.isVerified) {
      handleVerified()
    } else {
      handleUnverified()
    }
  }, [membership])

  return null
}

export default VerifyingView
